import { parseISO } from 'date-fns'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Tag } from '@/components'
import { HomeQualityCheckStatus } from '@/types/HomeQualityCheck'
import { HomesResponse } from '@/types/Homes'
import { formatDate } from '@/util'

type Props = {
  home: HomesResponse
}

const MobileHomeCard = ({ home }: Props) => {
  const navigate = useNavigate()

  function routeToHome(homeId?: number) {
    if (homeId) {
      navigate(`/homes/${homeId}`)
    }
  }

  const nextAvailableDate = formatDate(parseISO(home?.earliestAvailableDate || ''), 'MM/dd/yyyy')

  return (
    <div
      className="mb-4 w-full overflow-hidden rounded-md border border-border-primary p-4 shadow-md"
      onClick={() => routeToHome(home.id)}
      role={'presentation'}
    >
      <div className="mb-1 flex items-center justify-between">
        <p className="text-sm" style={{ fontWeight: 'bold' }}>
          {home?.searchDocument}
        </p>
        <Tag className="p-2 py-1 text-p-xs" variant={home?.blocked ? 'error' : 'success'}>
          {home?.blocked ? 'Blocked' : 'Not blocked'}
        </Tag>
      </div>
      <div className="mb-1 flex justify-between">
        <p className="flex-none py-2 text-sm text-grey-500">Home Quality Status</p>
        <Tag
          className="p-2 py-1 text-p-xs"
          variant={home?.homeQualityStatus === HomeQualityCheckStatus.READY ? 'success' : 'error'}
        >
          {home?.homeQualityStatus}
        </Tag>
      </div>
      <div className="mb-1 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Vacant Days</p>
        <p className="ml-3 flex-1 text-right font-bold text-sm">{home.vacantDays}</p>
      </div>
      <div className="mb-1 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Next Available</p>
        <p className="ml-3 flex-1 text-right font-bold text-sm">{nextAvailableDate}</p>
      </div>
    </div>
  )
}
export default MobileHomeCard
